//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poh', {
//        templateUrl: 'views/components/views/poh/poh.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'pohService', 'ttGridFactory', 'layoutService', function ($stateParams, stateService, utilityService, translateService, modalService, pohService, ttGridFactory, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let webPageName = stateService.getCurrentName();
//            let pohKeyno = $stateParams.poh_keyno;
//            let onDestroy = [];

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: '',
//                tt_warning_header: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                gridProductionOrdersReady: false,
//                bgPohMain: {
//                    selected: 'COMPONENTS',
//                    buttons: [
//                        { id: 'COMPONENTS', label: 'gb_poh_main_components', color: 'primary', onClick: () => vm.model.bgPohMain.selected = 'COMPONENTS' },
//                        { id: 'PO', label: 'gb_poh_main_pos', color: 'primary', onClick: () => vm.model.bgPohMain.selected = 'PO' },
//                        { id: 'FUNCTIONS', label: 'gb_poh_main_functions', color: 'primary', onClick: () => vm.model.bgPohMain.selected = 'FUNCTIONS' }
//                    ]
//                },
//                menu: {},
//                itemsListComponents: [],
//                itemsListProductionOrders: [],
//                changeStatusText: '',
//                changeStatusDisabled: true,
//                lockedGoToPoFinish: false,
//                lockedCancelCaseQtyOl: false,
//                lockedCancelCaseQty: false,
//                lockedDelete: false
//            };

//            vm.gridProductionOrders = new ttGridFactory({
//                rememberId: 'w_poh.poh_keyno',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            async function loadMenu() {
//                vm.model.menu = (await pohService.getMenu({ poh_keyno: pohKeyno }))[0];

//                retrieveStatusBtnState();
//                loadComponents();

//                if (vm.model.tabletSize.matches === false) {
//                    loadProductionOrders();
//                } else {
//                    loadGridProductionOrders();
//                }
//            }

//            async function retrieveStatusBtnState() {
//                if (utilityService.validateParmsValue(vm.model.menu.poh_keyno) !== true) return;

//                return pohService.getStatusBtnState({
//                    state: 'current',
//                    poh_keyno: vm.model.menu.poh_keyno
//                }).then((response) => {
//                    vm.model.changeStatusText = response.text;
//                    vm.model.changeStatusDisabled = response.disabled;
//                });
//            }

//            async function loadComponents() {
//                if (utilityService.validateParmsValue(vm.model.menu.poh_keyno) !== true) return;

//                vm.model.itemsListComponents = await pohService.listComponents({ poh_keyno: vm.model.menu.poh_keyno });
//            }

//            async function loadProductionOrders() {
//                if (utilityService.validateParmsValue(vm.model.menu.poh_keyno) !== true) return;

//                vm.model.itemsListProductionOrders = await pohService.listProductionOrders({ poh_keyno: vm.model.menu.poh_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGridProductionOrders() {
//                vm.gridProductionOrders.dataTask.loadData = {
//                    method: 2320,
//                    parameters: { poh_keyno: vm.model.menu.poh_keyno }
//                };

//                vm.model.gridProductionOrdersReady = true;

//                if (vm.gridProductionOrders.gridfunc !== null) vm.gridProductionOrders.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgPohMain = function (value) {
//                vm.model.bgPohMain.selected = value;
//            };

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region BUTTON FUNCTIONS

//            vm.cancelCaseQtyOl = function () {
//                vm.model.lockedCancelCaseQtyOl = true;

//                pohService.cancelCaseQtyOl({ poh_keyno: vm.model.menu.poh_keyno }).then((response) => {
//                    if (response && response.errorcode && response.errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.tt_warning_header,
//                            message: response.errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogInstance) => {
//                                    dialogInstance.close();
//                                    vm.model.lockedCancelCaseQtyOl = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedCancelCaseQtyOl = false
//                    }
//                });
//            };

//            vm.cancelCaseQty = function () {
//                vm.model.lockedCancelCaseQty = true;

//                pohService.cancelCaseQty({ poh_keyno: vm.model.menu.poh_keyno }).then((response) => {
//                    if (response && response.errorcode && response.errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.tt_warning_header,
//                            message: response.errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogInstance) => {
//                                    dialogInstance.close();
//                                    vm.model.lockedCancelCaseQty = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedCancelCaseQty = false;
//                    }
//                });
//            };

//            // #endregion BUTTON FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'pofinishprod':
//                        vm.model.lockedGoToPoFinish = true;

//                        pohService.createProductionOrderFinish({ poh_keyno: vm.model.menu.poh_keyno }).then((response) => {
//                            if (response) {
//                                if (response.errorcode && response.errorcode !== 0) {
//                                    modalService.show({
//                                        type: 'warning',
//                                        title: translations.tt_warning_header,
//                                        message: response.errormessage,
//                                        buttons: [{
//                                            label: translations.ok,
//                                            cssClass: 'btn-warning',
//                                            action: function (dialogInstance) {
//                                                dialogInstance.close();
//                                                vm.model.lockedGoToPoFinish = false;
//                                            }
//                                        }]
//                                    });
//                                } else if (response[0].p2_pofinishprod_keyno && response[0].p2_pofinishprod_keyno > 0) {
//                                    vm.model.lockedGoToPoFinish = false;
//                                    state = 'pofinishprod';

//                                    go({
//                                        p2_pofinishprod_keyno: Number.parseInt(response[0].p2_pofinishprod_keyno),
//                                        po_keyno: Number.parseInt(response[0].po_keyno)
//                                    });
//                                }
//                            }
//                        });
//                        break;
//                    case 'selectreport':
//                        go({
//                            webpage_name: webPageName,
//                            argtype: 'poh_keyno',
//                            argvalue: vm.model.menu.poh_keyno
//                        });
//                        break;
//                    case 'emailcreate':
//                        go({
//                            webpage: webPageName,
//                            argtype: 'poh_keyno',
//                            argvalue: vm.model.menu.poh_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON CHANGE STATUS FUNCTION

//            vm.changeStatus = function () {
//                pohService.getStatusBtnState({
//                    state: 'update',
//                    poh_keyno: vm.model.menu.poh_keyno
//                }).then((response) => {
//                    vm.model.changeStatusText = response.text;
//                    vm.model.changeStatusDisabled = response.disabled;

//                    if (response.errorcode !== null) {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.tt_warning_header,
//                            message: response.errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogInstance) => {
//                                    dialogInstance.close();
//                                }
//                            }]
//                        });
//                    }
//                });
//            };

//            // #endregion BUTTON CHANGE STATUS FUNCTION

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    pohService.deleteItem({ poh_keyno: vm.model.menu.poh_keyno }).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: (dialogItself) => {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                            stateService.back(2);
//                            //stateService.go('poshipmentplanning', {});
//                        }
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON WINDOW RESIZE FUNCTION

//            async function onWindowResize() {
//                if (vm.model.tabletSize.matches === false) {
//                    loadProductionOrders();
//                } else {
//                    loadGridProductionOrders();
//                }
//            }

//            // #endregion ON WINDOW RESIZE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();

//                window.addEventListener('resize', onWindowResize);
//                onWindowResize();
//            };

//            // #endregion ON INIT FUNCTION

//            // #region DESTROY FUNCTION

//            vm.$onDestroy = function () {
//                window.removeEventListener('resize', onWindowResize);

//                onDestroy.forEach((fn) => {
//                    if (typeof fn === 'function') fn();
//                });
//            };

//            // #endregion DESTROY FUNCTION

//        }]
//    });
//})();
